/* unplugin-vue-components disabled */module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"notRequired":"Необязательно"}}')
  delete Component.options._Ctor
}
